export default __webpack_public_path__ + "static/media/picture02.0a82708a.GIF";